import { gql } from "@apollo/client";

export const USER_REQUEST_PASSWORD = gql`
mutation RequestPasswordReset($emailAddress: String!) {
  requestPasswordReset(emailAddress: $emailAddress) {
    ... on Success {
      success
    }
    ... on ErrorResult {
      errorCode
      message
    }
  }
}
`;
